import { createFromIconfontCN } from '@ant-design/icons';
var CommonIcon = createFromIconfontCN({
    scriptUrl: [
        '//yx-web-nosdn.netease.im/sdk-release/yunxun-imweb-iconfont.js',
        '//at.alicdn.com/t/c/font_3429868_blvaz7v7n6p.js',
    ], // 在 iconfont.cn 上生成
});
export default CommonIcon;
